import { GlobalOutlined, InfoCircleOutlined, MailOutlined, PhoneOutlined, QuestionCircleOutlined, TeamOutlined, UserAddOutlined } from "@ant-design/icons";
import { Button, Card, Form, Input, message, Select, Space, Tooltip, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import api from "../../services/api";
import HeaderPage from "../HeaderPage";
import Sidebar from "../Sidebar";

const { Option } = Select;
const { Title, Text, Paragraph } = Typography;

interface ItemArmador {
  idArmador: string;
  name: string;
}

const AddFornecedores: React.FC = () => {
  const [armadores, setArmadores] = useState<ItemArmador[]>([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const routeChange = () => {
    navigate("/fornecedores");
  };

  useEffect(() => {
    api.get("filters/armadores").then((response) => {
      setArmadores(response.data);
    });
  }, []);

  const onFinish = async (values: any) => {
    const dataToSend = {
      ...values,
      tradelane: values.tradelane || [],
      email: localStorage.getItem("user_email"),
    };

    try {
      const response = await api.post("/fornecedor/add", dataToSend);
      if (response.data.success === true) {
        message.success("Fornecedor cadastrado com sucesso!");
        routeChange();
      } else {
        message.error(response.data.message);
      }
    } catch (err: any) {
      message.error(err.message);
    }
  };

  return (
    <div className="flex-dashboard">
      <Sidebar elementoAtivo="cotacoes_nac" />
      <main>
        <HeaderPage nomeOpcao="Fornecedores" />
        <div className="main-content">
          <Card
            title={
              <Space>
                <UserAddOutlined />
                <span>Supplier registration</span>
              </Space>
            }
            extra={
              <Tooltip title="Preencha os dados abaixo para adicionar um novo fornecedor ao sistema.">
                <QuestionCircleOutlined style={{ fontSize: 18 }} />
              </Tooltip>
            }
            style={{ maxWidth: 700, margin: "0 auto", marginTop: 24 }}
          >
            <Paragraph>
              <Text strong>
                Use this form to register a supplier associated with a shipowner and a freight forwarder.
              </Text>{" "}
              Fields marked as required must be filled out to complete the registration.
            </Paragraph>

            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              className="formulario"
            >
              <Form.Item
                label={
                  <span>
                    <GlobalOutlined /> Carrier or Supplier
                  </span>
                }
                name="armador"
                rules={[{ required: true, message: "Selecione um armador" }]}
              >
                <Select placeholder="Select a carrier or supplier">
                  {armadores.map((armador) => (
                    <Option key={armador.idArmador} value={armador.idArmador}>
                      {armador.name}
                    </Option>
                  ))}
                  <Option key={555} value={555}>
                    Freight Forwarder/NVOCC
                  </Option>
                </Select>
              </Form.Item>

              <Form.Item
                label={
                  <span>
                    <UserAddOutlined /> name
                  </span>
                }
                name="nome"
                rules={[{ required: true, message: "Digite o nome" }]}
              >
                <Input placeholder="Enter your full name" />
              </Form.Item>

              <Form.Item
                label={
                  <span>
                    <MailOutlined /> E-mail
                  </span>
                }
                name="email"
              >
                <Input type="email" placeholder="email@exemplo.com" />
              </Form.Item>

              <Form.Item
                label={
                  <span>
                    <PhoneOutlined /> Phone
                  </span>
                }
                name="phone"
              >
                <Input placeholder="(xx) xxxxx-xxxx" />
              </Form.Item>

              <Form.Item
                label={
                  <span>
                    <GlobalOutlined /> Department(s)
                    <Tooltip title="Use Ctrl (ou Cmd) para selecionar mais de um.">
                      <InfoCircleOutlined style={{ marginLeft: 8 }} />
                    </Tooltip>
                  </span>
                }
                name="tradelane"
                rules={[{ required: true, message: "Please select at least one department" }]}
              >
                <Select mode="multiple" placeholder="Selecione os departamentos">
                  <Option value="exportacao">Exportação</Option>
                  <Option value="importacao">Importação</Option>
                  <Option value="commodities">Commodities</Option>
                  <Option value="reefer">Reefer</Option>
                </Select>
              </Form.Item>

              <Form.Item style={{ textAlign: "right" }}>
                <Space>
                  <Button htmlType="reset">Clear</Button>
                  <Button type="primary" htmlType="submit">
                    Register
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </Card>
        </div>
      </main>
    </div>
  );
};

export default AddFornecedores;
